import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { TopicLink } from "scmp-app/components/topic/topic-link";

export const Container = styled.div``;

export const Title = styled.div`
  padding-block-end: 8px;

  color: #333333;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
`;

export const StyledTopicLink = styled(TopicLink)`
  display: inline;

  color: #666666;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 22.4px;
  word-break: break-word;

  &:hover {
    color: #2c4692;
    text-decoration: underline;
  }
`;

export const ItemsContainer = styled.div`
  /* topic link vertical divider */
  span {
    color: #cccccc;
  }
`;

export const Label = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 16px;
`;

export const ArticleTopicsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RelatedTopicsContainer = styled.div`
  display: flex;
  gap: 8px;

  margin-block: 20px 20px;
  padding-block-start: 20px;
  border-block-start: 1px solid #000000;
`;

export const RelatedTopicsLabel = styled.div`
  padding-block: 2px;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 18px;
`;

export const RelatedTopics = styled.div`
  flex: 1;
`;
